var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("h3", [
        _vm._v(
          _vm._s(
            _vm.$t("search.expert.corpusQueryLanguage") +
              (_vm.isParallelCorpus ? "" : ":")
          ) + "\n\t\t"
        ),
        _c(
          "a",
          {
            staticClass: "help",
            attrs: {
              target: "_blank",
              href: "https://inl.github.io/BlackLab/guide/corpus-query-language.html",
              title: _vm.$t("widgets.learnMore").toString(),
            },
          },
          [_vm._v("🛈")]
        ),
      ]),
      _vm._v(" "),
      !_vm.isParallelCorpus
        ? [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.mainQuery,
                  expression: "mainQuery",
                },
              ],
              staticClass: "form-control querybox",
              attrs: { name: "querybox", rows: "7" },
              domProps: { value: _vm.mainQuery },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.mainQuery = $event.target.value
                },
              },
            }),
          ]
        : _c(
            "div",
            { staticClass: "parallel" },
            [
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "control-label",
                    attrs: { for: "sourceVersion" },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("search.parallel.queryForSourceVersion")) +
                        "\n\t\t\t\t"
                    ),
                    _c("SelectPicker", {
                      attrs: {
                        id: "sourceVersion",
                        options: _vm.pSourceOptions,
                        "data-menu-width": "grow",
                        hideEmpty: "",
                      },
                      model: {
                        value: _vm.pSourceValue,
                        callback: function ($$v) {
                          _vm.pSourceValue = $$v
                        },
                        expression: "pSourceValue",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.mainQuery,
                      expression: "mainQuery",
                    },
                  ],
                  staticClass: "form-control querybox",
                  attrs: { name: "querybox", rows: "7" },
                  domProps: { value: _vm.mainQuery },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.mainQuery = $event.target.value
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _vm._l(_vm.pTargets, function (field, index) {
                return _c(
                  "div",
                  { key: field.value, staticClass: "form-group" },
                  [
                    _c(
                      "label",
                      {
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t" +
                            _vm._s(
                              _vm.$t("search.parallel.queryForTargetVersion")
                            ) +
                            "\n\t\t\t\t"
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "targetVersion",
                            attrs: {
                              type: "button",
                              title: _vm.$t("widgets.clickToRemove").toString(),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.removeTarget(field.value)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(field.label) +
                                "\n\t\t\t\t"
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("textarea", {
                      staticClass: "form-control querybox",
                      attrs: { rows: "7" },
                      domProps: { value: _vm.targetQueries[index] },
                      on: {
                        input: function ($event) {
                          return _vm.changeTargetQuery(index, $event)
                        },
                      },
                    }),
                  ]
                )
              }),
              _vm._v(" "),
              _vm.pTargetOptions.length
                ? _c("div", { staticClass: "form-group" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            _vm.pTargetValue.length
                              ? "search.parallel.addTargetVersion"
                              : "search.parallel.chooseTargetVersion"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c("SelectPicker", {
                          attrs: { options: _vm.pTargetOptions, hideEmpty: "" },
                          on: {
                            input: function ($event) {
                              return _vm.addTarget($event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("AlignBy", { attrs: { block: "" } }),
            ],
            2
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }